export enum ComputedPromotionStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  PAUSED = 'PAUSED',
  SCHEDULED = 'SCHEDULED',
  EXPIRED = 'EXPIRED',
  DELETED = 'DELETED',
}

export enum PromotionDiscountType {
  PERCENTAGE = 'PERCENTAGE',
  FIXED_AMOUNT = 'FIXED_AMOUNT',
}

export enum PromotionResourceType {
  CHARGER = 'CHARGER',
  LOCATION = 'LOCATION',
}

export enum PromoCodeResumeStrategy {
  NONE = 'NONE',
  ALL = 'ALL',
  SYSTEM_PAUSED_ONLY = 'SYSTEM_PAUSED_ONLY',
}

export interface Promotion {
  promotionId: string;
  companyId: string;
  name: string;
  label: Record<string, string>;
  validFrom?: string;
  validUntil?: string;
  publishedAt?: string;
  discountType: PromotionDiscountType;
  discountValue: number;
  applicableResources: Partial<Record<PromotionResourceType, string[]>>;
  promoCodeCount: number;
  internalNode?: string;

  status: ComputedPromotionStatus;
}

export interface PromotionList {
  totalCount: number;
  entities: Array<Promotion>;
}

export interface PromotionCreateRequest {
  companyId: string;
  name: string;
  label: Record<string, string>;
  internalNote: string | null;
  validFrom: string | null;
  validUntil: string | null;
  discountType: PromotionDiscountType;
  discountValue: number;
  applicableResources: Partial<Record<PromotionResourceType, string[]>> | null;
}

export interface PromotionUpdateRequest {
  name: string;
  label: Record<string, string>;
  internalNote: string | null;
  validFrom: string | null;
  validUntil: string | null;
  discountType: PromotionDiscountType;
  discountValue: number;
  applicableResources: Partial<Record<PromotionResourceType, string[]>> | null;
}

export interface PromotionPublishRequest {
  cascadeToPromoCodes: boolean;
}

export interface PromotionResumeRequest {
  promoCodeResumeStrategy: PromoCodeResumeStrategy | null;
}
